// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_common_service.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { Condition } from "./dto_report_condition_pb.js";
import { Tooth } from "./dto_report_tooth_pb.js";
import { Report } from "./dto_report_pb.js";
import { ToothLandmark } from "./dto_report_landmark_pb.js";
import { Asset } from "./dto_asset_pb.js";

/**
 * @generated from message com.diagnocat.model.ReportBundle
 */
export const ReportBundle = proto3.makeMessageType(
  "com.diagnocat.model.ReportBundle",
  () => [
    { no: 1, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 2, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 3, name: "Report", kind: "message", T: Report },
    { no: 4, name: "ToothLandmarks", kind: "message", T: ToothLandmark, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetWithDownloadURLs
 */
export const AssetWithDownloadURLs = proto3.makeMessageType(
  "com.diagnocat.model.AssetWithDownloadURLs",
  () => [
    { no: 1, name: "Asset", kind: "message", T: Asset },
    { no: 3, name: "DownloadURLs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message com.diagnocat.model.DebugResp
 */
export const DebugResp = proto3.makeMessageType(
  "com.diagnocat.model.DebugResp",
  () => [
    { no: 1, name: "OutputData", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

